import { Provider, NgModule, ModuleWithProviders, EnvironmentProviders } from '@angular/core';
import { UpdateService } from './update.service';
import { OnlineService } from './online.service';

@NgModule({
    declarations: [
    ],
    providers: [
    ],
    imports: [
    ],
    exports: [
    ]
})
export class UtilityModule {
    static forRoot(): ModuleWithProviders<UtilityModule> {
        return {
            ngModule: UtilityModule,
            providers: [
                UpdateService,
                OnlineService
            ]
        };
    }

    static forChild(): ModuleWithProviders<UtilityModule> {
        return {
            ngModule: UtilityModule,
            providers: []
        };
    }

    static getRootProviders(): Array<Provider | EnvironmentProviders> {
        return [
            UpdateService,
            OnlineService
        ];
    }
}
